import { BUSCAR_ENCOMENDA, SELECIONAR_ENCOMENDA } from '../../actions/types'

const initialState = undefined

const estadoInicial = {
  ultimoHistoricoEmissaoCte: { chaveCte: '', situacaotransmissao: { valor: ''}},
  formasPagamento: [],
  tipoServicoCte: {}, 
  naturezaOperacaoCte:{}, 
  enderecoRemetente: {}, 
  enderecoDestinatario: {}, 
  remetente: {}, 
  destinatario: {} 
}

export default function reducerEncomenda (state = estadoInicial, action = initialState) {
  switch (action.type) {
    case BUSCAR_ENCOMENDA: {
      return action.payload.data;
    }

    case SELECIONAR_ENCOMENDA: {
      return action.payload;
    }

    default: {
      return state
    }
  }
}
